import Layout from '@/layout/index.vue'

const route = [{
    path: '/system',
    component: Layout,
    redirect: '/404',
    hideMenu: true,
    meta: { title: '系统目录' },
    children: [
        {
            path: '/404',
            component: () => import('@/layout/system/404.vue'),
            meta: { title: '404', hideTabs: true }
        },
        {
            path: '/401',
            component: () => import('@/layout/system/401.vue'),
            meta: { title: '401', hideTabs: true }
        },
        {
            path: '/:path(.*)',
            component: () => import('@/layout/system/redirect.vue'),
            meta: { title: '页面不存在', hideTabs: true }
        }
    ]
  },{
    path: '/login',
    component: () => import('@/layout/system/Login'),
    hideMenu: true,
    meta: { title: '登录', hideTabs: true }
  }
]

export default route